import styled from "@emotion/styled";
import { Colors, Label, Spacing } from "@snapchat/snap-design-system";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
`;

export const CropperContainer = styled.div`
    position: relative;

    width: 100%;
    height: 250px;

    background-color: ${Colors.Black.V100};
    border-radius: ${Spacing.XS}px;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: ${Spacing.SM}px;
    align-items: flex-end;

    width: 100%;
    padding-top: ${Spacing.SM}px;
`;

export const Group = styled.div`
    display: flex;
    gap: ${Spacing.XS}px;
    align-items: flex-end;
`;

export const ScrubGroup = styled.div`
    display: flex;
    gap: ${Spacing.XS}px;
`;

export const ControlButtons = styled.button<{ active?: boolean }>`
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 30px;
    height: 30px;

    font-size: 20px;
    font-weight: bold;
    color: ${Colors.Black.V100};

    background-color: ${({ active }) => (active ? Colors.Green.V100 : Colors.WHITE)};
    border: none;
    border-radius: 50%;
    box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 40%);

    &:hover {
        background-color: ${Colors.Gray.V200};
    }
`;

export const ControlButtonGroup = styled.div<{ hasCropped: boolean }>`
    display: flex;
    gap: ${Spacing.XS}px;
    align-items: center;
    justify-content: center;

    width: ${({ hasCropped }) => (hasCropped ? "100%" : "auto")};
    margin-left: auto;
`;

export const ErrorLabel = styled(Label)`
    color: ${Colors.Red.V100};
`;
